<template>
  <v-navigation-drawer
    class="product-filters-sidebar"
    :elevation="0"
    :width="$vuetify.display.xs ? $vuetify.display.width : 390"
    :rounded="$vuetify.display.xs"
    :permanent="!$vuetify.display.xs && drawerStore.sidebarOpen"
    :disable-resize-watcher="true"
    :temporary="$vuetify.display.xs"
    :location="$vuetify.display.xs ? 'bottom' : 'start'"
    :model-value="drawerStore.sidebarOpen"
    :scrim="true"
    :touchless="true"
  >
    <div v-if="pdfStore.currentFile">
      <!-- Product Heading Block -->
      <div class="product-heading pa-6" :style="{ backgroundColor: product.color }">
        <v-img :src="product.emoji" :width="36" />
        <div class="mt-2">{{ product.title }}</div>
      </div>
      <!-- PDF Content Menu -->
      <div class="pa-2">
        <v-list v-model:opened="openSections" open-strategy="single">
          <PdfMenuListItem
            v-for="section in tableOfContents"
            :key="section.id"
            :item="section"
            :product-variant="product.variant"
          />
        </v-list>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { useDrawerStore } from "~/stores/drawerStore"
import { usePdfStore } from "~/stores/pdfStore"

export default {
  setup() {
    const drawerStore = useDrawerStore()
    const pdfStore = usePdfStore()
    return { drawerStore, pdfStore }
  },

  data() {
    return {
      pageTimer: null as any,
      openSections: [],
      scrollSectionIntoView: false,
    }
  },

  computed: {
    tableOfContents() {
      return this.pdfStore.currentFile.table_of_contents
    },

    product() {
      return this.pdfStore.currentFile?.product
    },

    selectedPath() {
      if (this.pdfStore.currentFile) {
        const pathByIds = this.pdfStore.recursiveChildrenSeeker(this.pdfStore.currentFile.table_of_contents)
        if (pathByIds && pathByIds.length > 0) {
          pathByIds.splice(-1)
        }
        return pathByIds
      }
      return []
    },
  },

  watch: {
    selectedPath: {
      handler() {
        this.openSections = this.selectedPath
      },
      deep: true,
    },

    "pdfStore.currentSectionId"(newValue) {
      if (newValue) {
        this.scrollSectionIntoView = true
      }
    },
  },

  mounted() {
    this.pageTimer = setInterval(this.tryUpdatingCurrentPage, 100)
  },

  unmounted() {
    clearInterval(this.pageTimer)
  },

  methods: {
    tryUpdatingCurrentPage() {
      const selectedElement = document.querySelector(".pdf-menu-list-item.book-index.selected") as any
      if (selectedElement) {
        this.pdfStore.currentSectionId = Number(selectedElement.dataset.id)
        if (this.scrollSectionIntoView) {
          selectedElement.scrollIntoView()
          this.scrollSectionIntoView = false
        }
      } else {
        this.pdfStore.currentSectionId = null
      }

      const iFrame = document.getElementsByClassName("pdf-viewer-iframe")[0]
      if (iFrame) {
        const pageNumberElement = iFrame.contentDocument.getElementById("pageNumber")
        if (pageNumberElement) {
          this.pdfStore.currentPage = pageNumberElement.value
        }
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.product-heading
  font-size: 18px
  font-weight: 700
  line-height: 26px
</style>
